import * as React from "react"
import { StaticImage } from "gatsby-plugin-image"

const AboutSection = (props) =>
{
  return (
    <section id="about-section" class="section is-medium has-background-info" >
      <div class="container is-max-desktop">
        <div class="has-text-centered" data-sal="slide-down"
          data-sal-delay="100"
          data-sal-easing="ease">
          <h1 class="title description mainfont  has-text-dark" >{props.title}</h1>
          <p class="description mainfont is-size-5 has-text-dark">
            {props.description}
          </p>
        </div>
        <br /><br />
        <div style={{ boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px" }}>
          <StaticImage
            src="../images/tarweweg.jpg"
            quality={100}
            formats={["AUTO", "WEBP", "AVIF"]}
            alt="Brand logo"
            imgStyle={{ width: "100%", height: "350px" }}
            style={{ width: "100%", height: "350px" }}
          />
        </div>
      </div>
    </section >
  )
}
export default AboutSection;